import { Box, Link, Radio, Text } from '@factorialco/deprecated-design-system'
import clouds from 'assets/images/import-clouds.svg'

import helpCenterUrl, { HelpCenterUrl } from 'modules/core/lib/helpCenterUrl'
import i18n from 'modules/core/lib/i18n'

// FIXME: Stop relying on components from the documents module
import DropzoneBox from 'modules/documents/components/Documents/DropzoneBox'
import CommonFileList from 'modules/documents/components/FileList'

import { Vendor } from '../../../types'
import { SamlForm } from '../../useSamlForm'

interface Props {
  form: SamlForm
  vendor: Vendor
  label: string
  helpCenterPage: HelpCenterUrl
  samlName?: string
  onSelect: (value: string) => unknown
  onFileDrop: (file: File) => unknown
}

function VendorBlock({
  form,
  vendor,
  label,
  helpCenterPage,
  samlName,
  onSelect,
  onFileDrop,
}: Props) {
  const droppedFile = form.values.droppedFile

  const handleFileDrop = async (files: File[]) => {
    const file = files[0]
    if (!file) return // TODO: Show error toast
    onFileDrop(file)
  }

  const handleDeleteFile = () => {
    form.setFieldValue('droppedFile', undefined)
    form.setFieldValue('metadata', undefined)
  }

  return (
    <Radio.Wrap>
      <Radio
        name={label}
        value={form.values.vendor ?? ''}
        option={{
          value: vendor,
          label: label,
        }}
        onChange={onSelect}
      >
        <Box gap="s16">
          {samlName && (
            <Box
              paddingX="s24"
              paddingY="s16"
              background="grey400"
              borderRadius={{
                all: 'abs008',
              }}
              gap="s12"
            >
              <Text.Normal>
                {i18n.t('settings.edit_company.saml_sso.modal.metadata.saml_name')}
              </Text.Normal>
              <Text.Normal weight="semibold">{samlName}</Text.Normal>
            </Box>
          )}
          {!droppedFile && (
            <DropzoneBox
              onDrop={handleFileDrop}
              icon={clouds}
              message={i18n.t('settings.edit_company.saml_sso.modal.metadata.drop_area')}
              accept={{ 'application/xml': [], 'text/xml': [] }}
              multiple={false}
            />
          )}
          {droppedFile && (
            <CommonFileList
              spaced={false}
              files={droppedFile ? [droppedFile] : []}
              onDeleteFile={handleDeleteFile}
            />
          )}
          {!droppedFile && (
            <Link.Href
              href={helpCenterUrl(helpCenterPage)}
              target="_blank"
              rel="noopener noreferrer"
            >
              {i18n.t('settings.edit_company.saml_sso.modal.metadata.help')}
            </Link.Href>
          )}
        </Box>
      </Radio>
    </Radio.Wrap>
  )
}

export default VendorBlock
